import gql from 'graphql-tag';

export default gql`
  mutation requestAccountDeletion($userId: UUID!) {
    requestAccountDeletion(userLoginId: $userId)
  }
`;
